module.exports = __webpack_public_path__ + "img/cptgb-1-en.3188c999.png";